export const PRODUCT_FORM_MAP = {
    'hiphos': {
        "HiPhos 5,000 GT": 5000,
        "HiPhos 10,000 GT": 10000,
        "HiPhos 20,000 GT": 20000,
        "HiPhos 20,000 L": 20000,
        "HiPhos 50,000 M": 50000,
        "HiPhos 50,000 L": 50000
    },
    'hiphorius': {
        'HiPhorius10 (10,000 FYT/g)': 20000,
        'HiPhorius40 (40,000 FYT/g)': 80000,
        'HiPhorius20 (L) (20,000 FYT/g)': 40000,
        'HiPhorius50 (L) (50,000 FYT/g)': 100000
    }
};

export const PRODUCT_FORM_MAP_DOSE = {
    'hiphos': {
        "HiPhos 5,000 GT": 5000,
        "HiPhos 10,000 GT": 10000,
        "HiPhos 20,000 GT": 20000,
        "HiPhos 20,000 L": 20000,
        "HiPhos 50,000 M": 50000,
        "HiPhos 50,000 L": 50000
    },
    'hiphorius': {
        'HiPhorius10 (10,000 FYT/g)': 10000,
        'HiPhorius40 (40,000 FYT/g)': 40000,
        'HiPhorius20 (L) (20,000 FYT/g)': 20000,
        'HiPhorius50 (L) (50,000 FYT/g)': 50000
    }
};

export const DOSE_FYT_MIN = {
    "Broiler": 500,
    "Swine": 500,
    "Layer": 300,
    "Aqua": 500,
    "Tilapia": 500,
    "Seabream": 500,
    "Trout": 500
};

export const DOSE_FYT_MAX = {
    "Broiler": 3000,
    "Swine": 3000,
    "Layer": 1800,
    "Aqua": 3000,
    "Tilapia": 3000,
    "Seabream": 3000,
    "Trout": 3000
};

export const PRODUCT_DEFAULT_PRICES = {
    'hiphos': {
        "HiPhos 10,000 GT": 4,
        "HiPhos 10,000 GT": 8,
        "HiPhos 20,000 GT": 15,
        "HiPhos 20,000 L": 14,
        "HiPhos 50,000 M": 35,
        "HiPhos 50,000 L": 30,
    },
    'hiphorius': {
        'HiPhorius10 (10,000 FYT/g)': 14,
        'HiPhorius40 (40,000 FYT/g)': 55,
        'HiPhorius20 (L) (20,000 FYT/g)': 27,
        'HiPhorius50 (L) (50,000 FYT/g)': 65
    }
    
};

export const PHOSPHATE_DEFAULT_PRICES = {
    "Aqua": {
        "PP": 0.550,
        "MSP": 0.540,
        "DCP": 0.425,
        "MCP": 0.510
    },
    "Tilapia": {
        "PP": 0.550,
        "MSP": 0.540,
        "DCP": 0.425,
        "MCP": 0.510
    },
    "Seabream": {
        "PP": 0.550,
        "MSP": 0.540,
        "DCP": 0.425,
        "MCP": 0.510
    },
    "Trout": {
        "PP": 0.550,
        "MSP": 0.540,
        "DCP": 0.425,
        "MCP": 0.510
    },
    "Broiler": {
        "TCP": 0.550,
        "MDCP": 0.540,
        "DCP": 0.425,
        "MCP": 0.510
    },
    "Layer": {
        "TCP": 0.550,
        "MDCP": 0.540,
        "DCP": 0.425,
        "MCP": 0.510
    },
    "Swine": {
        "TCP": 0.430,
        "MDCP": 0.490,
        "DCP": 0.425,
        "MCP": 0.510
    }
};

export const PHOSPHATE_DEFAULTS = {
    "Aqua": {
        "PP": { price: 0.750, total: 22.5, available: 90, fullName: 'Potassium Phosphate'},
        "MSP": {price: 0.725, total: 22.5, available: 89, fullName: 'MonoSodium Phosphate'},
        "DCP": {price: 0.550, total: 18, available: 82, fullName: 'Dicalcium Phosphate'},
        "MCP": { price: 0.700, total: 22.5, available: 76, fullName: 'Monocalcium Phosphate'},
    },
    "Tilapia": {
        "PP": { price: 0.750, total: 22.5, available: 90, fullName: 'Potassium Phosphate'},
        "MSP": {price: 0.725, total: 22.5, available: 89, fullName: 'MonoSodium Phosphate'},
        "DCP": {price: 0.550, total: 18, available: 82, fullName: 'Dicalcium Phosphate'},
        "MCP": { price: 0.700, total: 22.5, available: 76, fullName: 'Monocalcium Phosphate'},
    },
    "Seabream": {
        "PP": { price: 0.750, total: 22.5, available: 90, fullName: 'Potassium Phosphate'},
        "MSP": {price: 0.725, total: 22.5, available: 89, fullName: 'MonoSodium Phosphate'},
        "DCP": {price: 0.550, total: 18, available: 82, fullName: 'Dicalcium Phosphate'},
        "MCP": { price: 0.700, total: 22.5, available: 76, fullName: 'Monocalcium Phosphate'},
    },
    "Trout": {
        "PP": { price: 0.750, total: 22.5, available: 90, fullName: 'Potassium Phosphate'},
        "MSP": {price: 0.725, total: 22.5, available: 89, fullName: 'MonoSodium Phosphate'},
        "DCP": {price: 0.550, total: 18, available: 82, fullName: 'Dicalcium Phosphate'},
        "MCP": { price: 0.700, total: 22.5, available: 76, fullName: 'Monocalcium Phosphate'},
    },
    "Broiler": {
        "TCP": { price: 0.500, total: 18, available: 65, fullName: 'Tricalcium Phosphate', digFactor: 64},
        "MDCP": { price: 0.600, total: 21, available: 81, fullName: 'Monodicalcium Phosphate', digFactor: 80},
        "DCP": {price: 0.550, total: 18, available: 79, fullName: 'Dicalcium Phosphate', digFactor: 78, digestibleCaCoefficient: 0.42},
        "MCP": { price: 0.700, total: 22.5, available: 83, fullName: 'Monocalcium Phosphate', digFactor: 82, digestibleCaCoefficient: 0.35},
        "DFP": {price: 0.525, total: 18.25, available: 80, fullName: 'DeFluorinated Phosphate', digFactor: 78, digestibleCaCoefficient: 0.42},
    },
    "Layer": {
        "TCP": { price: 0.500, total: 18, available: 65, fullName: 'Tricalcium Phosphate', digFactor: 64 },
        "MDCP": { price: 0.600, total: 21, available: 81, fullName: 'Monodicalcium Phosphate', digFactor: 80 },
        "DCP": { price: 0.550, total: 18, available: 79, fullName: 'Dicalcium Phosphate', digFactor: 78 },
        "MCP": { price: 0.700, total: 22.5, available: 83, fullName: 'Monocalcium Phosphate', digFactor: 82 },
        "DFP": { price: 0.525, total: 18.25, available: 80, fullName: 'DeFluorinated Phosphate', digFactor: 78 },
    },
    "Swine": {
        "TCP": { price: 0.500, total: 18, available: 60, fullName: 'Tricalcium Phosphate'},
        "MDCP": { price: 0.600, total: 21, available: 80, fullName: 'Monodicalcium Phosphate'},
        "DCP": { price: 0.550, total: 18, available: 72, fullName: 'Dicalcium Phosphate'},
        "MCP": { price: 0.700, total: 22.5, available: 89, fullName: 'Monocalcium Phosphate'},
        "DFP": { price: 0.525, total: 18.25, available: 80, fullName: 'DeFluorinated Phosphate'},
    }
};

export const MATRIX_CALCIUM = {
    "Age, days": 17.0,
    "Intercept": -2.656331,
    "Limestone solubility, 15 min": 0.023239,
    "Limestone solubility, 15 min*Limestone solubility, 15 min": -0.000126,
    "Total Ca, %": 1.3987496,
    "Total Ca, %*Total Ca, %": -0.838356,
    "Ln phytase": 0.0181628,
    "Particle size, mm": 0.8787857,
    "Limestone solubility, 15 min*Particle size, mm": -0.011367,
    "Age": -0.003032,
    "Phytate P, %": 9.4465422,
    "Phytate P, %*Phytate P, %": -12.30111,
    "Total Ca, %*Phytate P, %": -5.37953,
    "Total Ca, %*Total Ca, %*Phytate P, %": 3.1369315,
};

export const DIG_PHOSPHORUS = {
    "Intercept": 0.1165608,
    "Log phytase": -0.062699,
    "Total Ca, %": 0.726008,
    "Phytate P, %": -2.08322,
    "Total Ca, %*Total Ca, %": -0.512824,
    "Limestone solubility, 15 min": 0.0006331,
    "Phytate P, %*Log phytase": 0.3965458,
    "Age": -0.001164,
    "Age, days": 17
};

export const CALCIUM_DEFAULTS = {
    "totalCa": {
        default: 0.70,
        min: 0.50,
        max: 1.00,
        step: 0.01
    },
    "totalCaSwine": {
        default: 0.60,
        min: 0.40,
        max: 0.80,
        step: 0.01
    },
    "totalNPP": {
        default: 0.25,
        min: 0.12,
        max: 0.60,
        step: 0.01
    },
    "totalSolubility": {
        default: 81,
        min: 53,
        max: 96,
        step: 1
    },
    "particleSize": {
        default: 0.25,
        min: 0.08,
        max: 0.45,
        step: 0.01
    },
    "digestibleCaCoefficient": {
        default: 50,
        min: 45,
        max: 77,
        step: 1
    },
    "inorganicP": {
        default: "DCP"
    },
};

export const TOTAL_MATRIX_CALCIUM = {
    "first": 0.55,
    "second": 0.4,
};

export const AQUA_PHOSPOHOROUS_EXCRETION_CONSTANTS = {
    "Tilapia": {
        0: -23.9449232188985,
        500: -29.2445842924208,
        750: -32.0537862190852,
        1000: -34.8375564542614,
        1250: -35,
        1500: -34.8375564542614,
        1750: -21,
        2000: -7.14378693613131,
        2250: -7.14378693613131,
        2500: -7.14378693613131,
        2750: -7.14378693613131,
        3000: -7.14378693613131,
    },
    "Trout": {
        0: -27,
        500: -32,
        750: -31,
        1000: -35,
        1250: -35,
        1500: -35,
        1750: -27,
        2000: -19,
        2250: -19,
        2500: -19,
        2750: -19,
        3000: -19,
    },
    "Seabream": {
        0: -23,
        500: -32,
        750: -24,
        1000: -36,
        1250: -36,
        1500: -36,
        1750: -31,
        2000: -27,
        2250: -27,
        2500: -27,
        2750: -27,
        3000: -27,
    },
}